import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    title: { type: String, default: "Are you sure?" },
    message: { type: String, default: "This action cannot be undone." },
    confirmText: { type: String, default: "Confirm" },
    cancelText: { type: String, default: "Cancel" },
    url: String,
    method: { type: String, default: "delete" }
  }

  show(event) {
    event.preventDefault()

    const dialog = document.createElement("dialog")
    dialog.className = "modal"
    dialog.innerHTML = `
      <div class="modal-box">
        <h3 class="text-lg font-bold font-display">${this.titleValue}</h3>
        <p class="py-4 text-base-content/70">${this.messageValue}</p>
        <div class="modal-action">
          <button class="btn btn-ghost" data-dismiss>
            ${this.cancelTextValue}
          </button>
          <form method="post" action="${this.urlValue}">
            <input type="hidden" name="_method" value="${this.methodValue}">
            <input type="hidden" name="authenticity_token" value="${document.querySelector('meta[name=csrf-token]')?.content}">
            <button type="submit" class="btn btn-error">
              ${this.confirmTextValue}
            </button>
          </form>
        </div>
      </div>
      <form method="dialog" class="modal-backdrop"><button>close</button></form>
    `

    document.body.appendChild(dialog)
    dialog.showModal()

    dialog.querySelector("[data-dismiss]").addEventListener("click", () => {
      dialog.close()
      dialog.remove()
    })

    dialog.addEventListener("close", () => dialog.remove())
  }
}
